import { render, staticRenderFns } from "./PreviewModelCard.vue?vue&type=template&id=7c068b10&scoped=true"
import script from "./PreviewModelCard.vue?vue&type=script&lang=js"
export * from "./PreviewModelCard.vue?vue&type=script&lang=js"
import style0 from "./PreviewModelCard.vue?vue&type=style&index=0&id=7c068b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c068b10",
  null
  
)

export default component.exports